module.exports = __webpack_public_path__ + "fonts/NotoSans-Bold.a123e4ed.woff";